import { Component } from 'preact';
import handleLoadingAndError from '../handle-loading-and-error';
import Table from '../table';
import style from './style.scss';
import CardDateLabel from '../card-date-label';
import { formatRainfall, formatTemperature, formatWindGust, getDateTimeFormatConverter } from '../../utils/formatters';
import {
	HighlightHighTemperature,
	HighlightLowTemperature, HighlightMeanTemperature,
	HighlightRainfall,
	HighlightWindGust
} from '../highlight-values';
import { convertWindBearing8 } from '../../utils/convert-wind-bearing';

/**
 * The TodayInPreviousYears component displays some extremes data
 * from previous years
 */
class TodayInPreviousYears extends Component {

	constructor(props, context) {
		super(props, context);

		this.units = context.userSettings.units;

		this.formatters = {
			date: getDateTimeFormatConverter('%Y-%m-%d', '%-d %B'),
			temperature: t => formatTemperature(t, this.units.temperature),
			windGust: g => formatWindGust(g, this.units.speed),
			rainfall: r => formatRainfall(r, this.units.rain)
		};
	}

	render(props) {
		const date = this.formatters.date(props.data.date);

		return (
			<div class={style.today_in_previous_years}>
				<CardDateLabel date={date} />
				<Table>
					<tbody>
					<tr>
						<td>Highest temperature</td>
						<td>
							<HighlightHighTemperature>
								{ this.formatters.temperature(props.data.highestTemperature.value) + '°' +  this.units.temperature }
							</HighlightHighTemperature>
						</td>
						<td>{ props.data.highestTemperature.year }</td>
					</tr>
					<tr>
						<td>Lowest temperature</td>
						<td>
							<HighlightLowTemperature>
								{ this.formatters.temperature(props.data.lowestTemperature.value) + '°' +  this.units.temperature }
							</HighlightLowTemperature>
						</td>
						<td>{ props.data.lowestTemperature.year }</td>
					</tr>
					<tr>
						<td>Mean temperature</td>
						<td>
							<HighlightMeanTemperature>
								{ this.formatters.temperature(props.data.meanTemperature.value) + '°' +  this.units.temperature }
							</HighlightMeanTemperature>
						</td>
						<td />
					</tr>
					<tr>
						<td>Highest wind gust</td>
						<td>
							<HighlightWindGust>
								{ convertWindBearing8(props.data.highestWindGust.bearing) + ' ' + this.formatters.windGust(props.data.highestWindGust.value) + ' ' +  this.units.speed }
							</HighlightWindGust>
						</td>
						<td>{ props.data.highestWindGust.year }</td>
					</tr>
					<tr>
						<td>Highest rainfall</td>
						<td>
							<HighlightRainfall>
								{ this.formatters.rainfall(props.data.highestRainfall.value) + ' ' +  this.units.rain }
							</HighlightRainfall>
						</td>
						<td>{ props.data.highestRainfall.year }</td>
					</tr>
					</tbody>
				</Table>
			</div>
		);
	}

}

export default handleLoadingAndError(TodayInPreviousYears);



// WEBPACK FOOTER //
// ./components/today-in-previous-years/index.js